var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowercase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lowercase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.5 8V18M23 8V17.5416C23 20.6119 20.845 23 17.5521 23C15.7603 23 14.138 22.2267 13 20.5892M9.49994 12.8931C9.49994 15.4697 7.59716 17.5584 5.24997 17.5584C2.90278 17.5584 1 15.4697 1 12.8931C1 10.3165 2.90278 8.22779 5.24997 8.22779C7.59716 8.22779 9.49994 10.3165 9.49994 12.8931ZM22.9999 12.8933C22.9999 15.4699 21.0972 17.5587 18.75 17.5587C16.4028 17.5587 14.5 15.4699 14.5 12.8933C14.5 10.3168 16.4028 8.22803 18.75 8.22803C21.0972 8.22803 22.9999 10.3168 22.9999 12.8933Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowercase);
export default __webpack_public_path__ + "static/media/lowercase.a50af087549b7b441bdbc63a3ace1795.svg";
export { ForwardRef as ReactComponent };